export default "__VITE_ASSET__Cnzm99ql__"